module.exports = __webpack_public_path__ + "static/oir-84bb9261516a3d34284da7adac1a9752.mp4";